import { render, staticRenderFns } from "./ReceiveRedirect.vue?vue&type=template&id=7d3987b9&"
import script from "./ReceiveRedirect.vue?vue&type=script&lang=js&"
export * from "./ReceiveRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports